export default "__VITE_ASSET__BuARn$rs__"